var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowTurnDownRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12030_3170)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2275 12.7275L13.935 16.155C13.7175 16.3875 13.4175 16.5 13.125 16.5C12.8325 16.5 12.5625 16.395 12.345 16.185C11.895 15.75 11.88 15.045 12.315 14.595L14.8125 12H4.125C1.8525 12 0 10.1475 0 7.875V2.625C0 2.0025 0.5025 1.5 1.125 1.5C1.7475 1.5 2.25 2.0025 2.25 2.625V7.875C2.25 8.91 3.09 9.75 4.125 9.75H14.8125L12.315 7.155C11.8875 6.705 11.895 5.9925 12.345 5.565C12.795 5.1375 13.5075 5.145 13.935 5.595L17.2425 9.0375C18.2475 10.0425 18.2475 11.7075 17.2275 12.735V12.7275Z",
    fill: "#3F4254"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12030_3170"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTurnDownRight);
export default __webpack_public_path__ + "static/media/arrow-turn-down-right.ebdfe2df2ed090f5f3b2b186d42e94a3.svg";
export { ForwardRef as ReactComponent };